import api from "../../hooks/useApi";
import {Outlet, useLoaderData, NavLink, defer} from "react-router-dom";
import {Container, Box, Grid, Button, Typography, Paper} from "@mui/material";
import StyledMenuItems from "../../components/StyledMenuItems";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PageTitle from '../../components/PageTitle';
import AuthProvider from '../../hooks/authProvider';

export async function loader({request, params}) {
    const id = params.object_id;
    const user = await AuthProvider.getUserDetails();
    const form = (await api.get(`/api/HotelObj/form/get/${id}/`)).data.form;
    const object = (await api.get(`/api/HotelObj/${id}/`)).data;
    const childrenObj = object.children_obj;
    if (childrenObj.length > 0) {
        const childrenForms = {};
        const childrenObjects = await Promise.all(
            childrenObj.map(async (childID) => {
                const response = await api.get(`/api/HotelObjChildren/${childID}/`);
                childrenForms[childID] = (await api.get(`/api/HotelObjChildren/form/get/${childID}/`)).data.form;
                return response.data;
            })
        )
        object.children_obj = childrenObjects;
        object.children_forms = childrenForms;
    }
    // if (object.rates.length > 0 && checkIfArrayIsID(object.rates)) {
    //     object.rates = await Promise.all(
    //         object.rates.map(async (rateID) => {
    //             const response = await api.get(`/api/HotelRates/${rateID}/`)
    //             return response.data;
    //         })
    //     )
    // }
    // if (object.price.length > 0 && checkIfArrayIsID(object.price)) {
    //     object.price = await Promise.all(
    //         object.price.map(async (rateID) => {
    //             const response = await api.get(`/api/HotelPrice/${rateID}/`)
    //             return response.data;
    //         })
    //     )
    // }

    return defer({id: id, hotelObj: object, form: form, user});
}

export default function SingleObjectLayout() {
    const loaderData = useLoaderData();
    const objectName = loaderData?.hotelObj?.name;
    const objectLabel = objectName ? `«${objectName}»` : `ID ${loaderData?.id || ""}`.trim();
    return (
        <Container maxWidth='false'>
            <PageTitle title={`Об'єкт ${objectLabel}`} />
            <Box className='spacer-profile' marginBottom={{lg: '125px', xs: '20px'}}/>
            <Box>
                <Grid container spacing={2} className='profile-links'>
                    {/* container for links */}
                    <StyledMenuItems item xs={12} md={2} container spacing={2} style={{height: 'fit-content'}}>
                        <Grid item xs={12}>
                            <Button fullWidth
                                    to={`/object/${loaderData.id}/details`}
                                    variant='contained'
                                    component={NavLink}
                                    startIcon={<InfoOutlinedIcon/>}
                            >
                                <Typography variant='body1' color='text.primary'>
                                    Загальна інформація
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth
                                    to={`/object/${loaderData.id}/calendar`}
                                    variant='contained'
                                    component={NavLink}
                                    startIcon={<CalendarMonthIcon/>}
                            >
                                <Typography variant='body1' color='text.primary'>
                                    Календар
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth
                                    to={`/object/${loaderData.id}/tariffs`}
                                    variant='contained'
                                    component={NavLink}
                                    startIcon={<ListAltOutlinedIcon/>}
                            >
                                <Typography variant='body1' color='text.primary'>
                                    Тарифи та ціни
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth
                                    to={`/object/${loaderData.id}/rules`}
                                    variant='contained'
                                    component={NavLink}
                                    startIcon={<ListAltOutlinedIcon/>}
                            >
                                <Typography variant='body1' color='text.primary'>
                                    Правило проживання
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth
                                    to={`/object/${loaderData.id}/children_tarrifs`}
                                    variant='contained'
                                    component={NavLink}
                                    startIcon={<ListAltOutlinedIcon/>}
                            >
                                <Typography variant='body1' color='text.primary'>
                                    Тарифи для дітей
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth
                                    to={`/object/${loaderData.id}/photos`}
                                    variant='contained'
                                    component={NavLink}
                                    startIcon={<InsertPhotoOutlinedIcon/>}
                            >
                                <Typography variant='body1' color='text.primary'>
                                    Фото
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth
                                    to={`/object/${loaderData.id}/children`}
                                    variant='contained'
                                    component={NavLink}
                                    startIcon={<HolidayVillageOutlinedIcon/>}
                            >
                                <Typography variant='body1' color='text.primary'>
                                    Підоб'єкти
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth
                                    to={`/object/${loaderData.id}/user_rights`}
                                    variant='contained'
                                    component={NavLink}
                                    startIcon={<KeyOutlinedIcon/>}

                            >
                                <Typography variant='body1' color='text.primary'>
                                    Права користувачів
                                </Typography>
                            </Button>
                        </Grid>
                    </StyledMenuItems>
                    <Grid item xs={12} md={10} container>
                        <Box width="100%" maxWidth="100vw">
                            <Paper style={{padding: '15px', outline: '1px solid #9A9FA4', display: 'flex'}}
                                   elevation={0}>
                                <Outlet/>
                            </Paper>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    )
}
export const checkIfArrayIsID = (array) => {
    return array.every((element) => typeof element === 'number');
}
